import {
  LOAD_DATA,
  LOAD_DATA_VIA_TOKEN,
  LOGOUT,
  CHANGE_ACTIVE_ACCOUNT,
  UPDATE_ACTIVE_ACCOUNT
} from "../actions";
import { clearState } from "../utils/sessionStorage";
import { initialState } from "./index";

export default function appReducer(state, action) {
  switch (action.type) {
    case LOGOUT:
      clearState();
      return Object.assign({}, state, initialState);
    case LOAD_DATA:
      return {
        ...state,
        isAuth: true,
        user: {
          id: action.payload.id,
          name: action.payload.name,
          email: action.payload.email,
          authentication_token: action.payload.authentication_token,
          client_id: action.payload.client_id,
          profile: action.payload.profile,
          can_create_campaign_sending:
            action.payload.can_create_campaign_sending
        },
        activeAccount: getDefaultAccountFromPayload(action.payload.accounts),
        accounts: [...action.payload.accounts]
      };
    case LOAD_DATA_VIA_TOKEN:
      return {
        ...state,
        isAuth: true,
        showModalPassword: true,
        user: {
          id: action.payload.id,
          name: action.payload.name,
          email: action.payload.email,
          authentication_token: action.payload.authentication_token,
          client_id: action.payload.client_id,
          profile: action.payload.profile,
          can_create_campaign_sending:
            action.payload.can_create_campaign_sending
        },
        activeAccount: getDefaultAccountFromPayload(action.payload.accounts),
        accounts: [...action.payload.accounts]
      };
    case CHANGE_ACTIVE_ACCOUNT:
      return {
        ...state,
        activeAccount: getActiveAccountViaId(state.accounts, action.id)
      };
    case UPDATE_ACTIVE_ACCOUNT:
      return updateAccounts(state, action.campaign);
    default:
      return state;
  }
}

function updateAccounts(state, campaign) {
  var activeAccountId = state.activeAccount._id;
  var newState = Object.assign({}, state);
  newState.accounts.forEach(account => {
    if (account._id === activeAccountId) {
      account.campaigns = [campaign, ...account.campaigns];
    }
  });
  return newState;
}

function getDefaultAccountFromPayload(accounts) {
  let activeAccount;
  accounts.forEach(account => {
    if (account.default === true) {
      activeAccount = account;
    }
  });
  return activeAccount;
}

function getActiveAccountViaId(accounts, id) {
  let activeAccount;
  accounts.forEach(account => {
    if (account._id === id) {
      activeAccount = account;
    }
  });
  return activeAccount;
}



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js